import { fixedUi } from '@/i18n/fixedUi';
import React from 'react';

export default function ShopPublishPermissionPanel({
  loading,
  error,
  canPublishProduct,
  reason,
}) {
  if (loading) {
    return <p className="spo-return-detail__empty">{fixedUi("正在查询店铺发品资格…")}</p>;
  }

  if (error) {
    return <p className="spo-shop-info__inline-error" role="alert">{error}</p>;
  }

  if (canPublishProduct == null) {
    return <p className="spo-return-detail__empty">{fixedUi("暂无发品资格数据，请同步后查看。")}</p>;
  }

  const blocked = !canPublishProduct;
  const platformQueryFailed = typeof reason === 'string'
    && /暂时无法确认|处置数据|查询供应商/.test(reason);
  const rows = [
    {
      key: 'canPublishProduct',
      label: '是否可发品',
      value: blocked
        ? (platformQueryFailed ? '暂无法确认' : '不可发品')
        : '可发品',
    },
    {
      key: 'reason',
      label: platformQueryFailed ? fixedUi("说明") : '不可发品原因',
      value: blocked ? (reason || '—') : '—',
    },
  ];

  return (
    <div data-testid="shein-publish-permission">
      <table className="spo-return-detail__kv">
        <tbody>
          {rows.map((row) => (
            <tr key={row.key}>
              <th scope="row">{row.label}</th>
              <td>
                {row.key === 'canPublishProduct' ? (
                  <span className={`spo-records__status spo-records__status--${blocked ? 'failed' : 'success'}`}>
                    {row.value}
                  </span>
                ) : row.value}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {blocked ? (
        <p className="spo-shop-info__panel-hint">
          {platformQueryFailed
            ? '这是 SHEIN 平台侧返回的异常，可稍后再次同步；或登录商家后台核对店铺处置/违规状态。'
            : '请前往 SHEIN 商家后台处理相关问题后再尝试发品。'}
        </p>
      ) : (
        <p className="spo-shop-info__panel-hint">{fixedUi("当前店铺具备发布商品资格。")}</p>
      )}
    </div>
  );
}
